import {
  FilterMode,
  EsignatureConfigCreateMutationVariables,
  EsignatureConfig_OrderBy,
  EsignatureConfig,
  SortOrder,
  EsignatureConfig_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const esignatureConfigService = {
  createOne: buildCreateOne(
    (
        esignatureConfigCreateVariables: EsignatureConfigCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.esignatureConfigCreate(
          esignatureConfigCreateVariables
        );
        return result.esignatureConfigCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.esignatureConfigOne({ id });
    return result.esignatureConfigOne as EsignatureConfig;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: EsignatureConfig_OrderBy[] | null = null,
    filter: EsignatureConfig_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EsignatureConfig_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.esignatureConfigListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.esignatureConfigListWithOffset
    ) as EsignatureConfig[];
    return { list, orderBy };
  },
};
